import { render, staticRenderFns } from "./BarcodesAssemblyHistory.vue?vue&type=template&id=5ee10b08&scoped=true&"
import script from "./BarcodesAssemblyHistory.vue?vue&type=script&lang=js&"
export * from "./BarcodesAssemblyHistory.vue?vue&type=script&lang=js&"
import style0 from "./BarcodesAssemblyHistory.vue?vue&type=style&index=0&id=5ee10b08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee10b08",
  null
  
)

export default component.exports